import React from 'react';
import ModuleCard from './ModuleCard';
import RecommendedCourseCard from './RecommendedCourseCard';
import ModuleCardAdmin from './ModuleCardAdmin/index';
import ToDo from './ToDo';
import { Widget, WidgetHeader, WidgetTitle } from '@/components/custom/widget';

export default function Example() {
  return (
    <div className="main-content main-content--block">
      <Widget>
        <WidgetHeader>
          <WidgetTitle>Module card</WidgetTitle>
        </WidgetHeader>
        <ModuleCard />
      </Widget>

      <Widget>
        <WidgetHeader>
          <WidgetTitle>Recommended course card</WidgetTitle>
        </WidgetHeader>
        <div className="recommended-course-card-wrapper">
          <RecommendedCourseCard />
          <RecommendedCourseCard />
          <RecommendedCourseCard />
          <RecommendedCourseCard />
        </div>
      </Widget>

      <Widget>
        <WidgetHeader>
          <WidgetTitle>Module card admin</WidgetTitle>
        </WidgetHeader>
        <ModuleCardAdmin id={1} />
      </Widget>

      <Widget>
        <WidgetHeader>
          <WidgetTitle>To do card (second version)</WidgetTitle>
        </WidgetHeader>

        <div className="card__todo-wrapper">
          <ToDo />
        </div>
      </Widget>
    </div>
  );
}
